import { useEffect, useRef } from "react"
import { useSearchParams } from "react-router-dom"
import { useFilterStore } from "./model/filter-store.js"
import { mergeIntoParams, parseFilters, sameUrl } from "@csbi/contracts"

export function useFilterUrlSync() {
  const [params, setParams] = useSearchParams()
  const filters = useFilterStore((s) => s.filters)
  const hydrated = useFilterStore((s) => s.hydrated)
  const hydrate = useFilterStore((s) => s.hydrate)
  const replace = useFilterStore((s) => s.replace)

  const setParamsRef = useRef(setParams)
  useEffect(() => {
    setParamsRef.current = setParams
  }, [setParams])

  useEffect(() => {
    hydrate(parseFilters(new URLSearchParams(window.location.search)))
  }, [hydrate])

  useEffect(() => {
    if (!hydrated) return
    const next = mergeIntoParams(new URLSearchParams(window.location.search), filters)
    if (next.toString() !== window.location.search.replace(/^\?/, "")) {
      setParamsRef.current(next, { replace: true })
    }
  }, [filters, hydrated])

  useEffect(() => {
    if (!hydrated) return
    const fromUrl = parseFilters(params)
    if (!sameUrl(fromUrl, filters)) replace(fromUrl)
    // Deliberately depends on params only: filters changes are the previous effect's job, and adding them here would make a loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, hydrated])
}
